import { motion } from "framer-motion";
import { Calendar, DollarSign, Users } from "lucide-react";

export const WeeklyHighlights = ({ announcements }) => {
  const getTypeIcon = (type) => {
    switch (type) {
      case "scholarship":
        return <DollarSign className="w-5 h-5 text-[#80e280]" />;
      case "event":
        return <Users className="w-5 h-5 text-[#80e280]" />;
      case "deadline":
        return <Calendar className="w-5 h-5 text-[#80e280]" />;
      default:
        return <Calendar className="w-5 h-5 text-[#80e280]" />;
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case "scholarship":
        return "border-green-200 bg-green-50";
      case "event":
        return "border-blue-200 bg-blue-50";
      case "deadline":
        return "border-red-200 bg-red-50";
      default:
        return "border-gray-200 bg-gray-50";
    }
  };

  return (
    <div className="shadow-lg bg-white p-4 rounded-lg h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-gray-900">
          📢 Weekly Highlights
        </h3>
      </div>

      <div>
        {announcements.map((currentAnnouncement, currentIndex) => {
          return (
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
              className={`p-6 rounded-xl border-2 ${getTypeColor(
                currentAnnouncement.type
              )} mb-2`}
            >
              <div className="flex items-start space-x-4 text-left">
                <div className="flex-shrink-0">
                  {getTypeIcon(currentAnnouncement.type)}
                </div>

                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <h4 className="font-semibold text-gray-900 text-base">
                      {currentAnnouncement.title}
                    </h4>
                    {currentAnnouncement.urgent && (
                      <span className="px-2 py-1 bg-red-100 text-red-800 text-sm font-medium rounded-full">
                        Urgent
                      </span>
                    )}
                  </div>

                  <p className="text-gray-600 mb-4 text-base mb-0">
                    {currentAnnouncement.description}
                  </p>

                  <div className="flex items-center justify-between">
                    <span className="text-base text-gray-500">
                      {currentAnnouncement.date}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};
